<template>
  <div class="usuarios-lista">
    <div class="content-header">
      <div class="content-header-left">
        <h1 class="content-header-title">Lista de Usuarios</h1>
        <p class="content-header-subtitle">Gestiona todos los usuarios del sistema</p>
      </div>
      <div class="content-header-right">
        <b-button variant="primary" @click="nuevoUsuario">
          <feather-icon icon="PlusIcon" size="16" class="mr-50" />
          Nuevo Usuario
        </b-button>
      </div>
    </div>

    <b-card>
      <div v-if="cargando" class="text-center py-4">
        <b-spinner variant="primary" />
        <p class="mt-2">Cargando usuarios...</p>
      </div>
      
      <div v-else-if="error" class="text-center py-4">
        <b-alert variant="danger" show>
          {{ error }}
        </b-alert>
        <b-button variant="primary" @click="cargarUsuarios">
          Reintentar
        </b-button>
      </div>
      
      <b-table
        v-else
        :items="usuariosConNombreCompleto"
        :fields="usuariosFields"
        responsive
        striped
        hover
        show-empty
        empty-text="No hay usuarios registrados"
      >
        <template #cell(fechaRegistro)="data">
          {{ data.item.fechaRegistro ? new Date(data.item.fechaRegistro).toLocaleDateString() : '-' }}
        </template>
        <template #cell(acciones)="data">
          <b-button-group size="sm">
            <b-button variant="outline-primary" @click="verUsuario(data.item.idUsuario)">
              <feather-icon icon="EyeIcon" size="14" />
            </b-button>
            <b-button variant="outline-warning" @click="editarUsuario(data.item.idUsuario)">
              <feather-icon icon="EditIcon" size="14" />
            </b-button>
            <b-button variant="outline-danger" @click="eliminarUsuario(data.item.idUsuario)">
              <feather-icon icon="TrashIcon" size="14" />
            </b-button>
          </b-button-group>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import usuarioService from '@/services/usuarioService'

export default {
  name: 'UsuariosLista',
  data() {
    return {
      usuariosFields: [
        { key: 'nombreCompleto', label: 'Nombre Completo' },
        { key: 'email', label: 'Email' },
        { key: 'nombreRol', label: 'Rol' },
        { key: 'fechaRegistro', label: 'Fecha Registro' },
        { key: 'acciones', label: 'Acciones' },
      ],
      usuarios: [],
      cargando: false,
      error: null,
    }
  },
  async mounted() {
    await this.cargarUsuarios()
  },
  methods: {
    async cargarUsuarios() {
      this.cargando = true
      this.error = null
      try {
        this.usuarios = await usuarioService.getAllUsuarios()
        
        // Si la lista está vacía, no mostrar error, solo log
        if (this.usuarios.length === 0) {
          console.log('No hay usuarios disponibles')
        }
      } catch (error) {
        console.error('Error al cargar usuarios:', error)
        
        // Solo mostrar error si no es un 404 (que ya se maneja en el servicio)
        if (error.response?.status !== 404) {
          this.error = 'Error al cargar la lista de usuarios'
          this.$toast.error('Error al cargar usuarios')
        } else {
          // Para 404, simplemente mostrar lista vacía
          this.usuarios = []
        }
      } finally {
        this.cargando = false
      }
    },
    nuevoUsuario() {
      this.$router.push({ name: 'usuarios-nuevo' })
    },
    verUsuario(id) {
      this.$router.push({ name: 'usuarios-detalle', params: { id } })
    },
    editarUsuario(id) {
      this.$router.push({ name: 'usuarios-editar', params: { id } })
    },
    async eliminarUsuario(id) {
      try {
        await this.$swal({
          title: '¿Estás seguro?',
          text: 'Este usuario será eliminado permanentemente',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, eliminar',
          cancelButtonText: 'Cancelar',
        })
        
        await usuarioService.deleteUsuario(id)
        await this.cargarUsuarios() // Recargar la lista
        
        this.$toast.success('Usuario eliminado correctamente')
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Error al eliminar usuario:', error)
          this.$toast.error('Error al eliminar usuario')
        }
      }
    },
  },
  computed: {
    usuariosConNombreCompleto() {
      return this.usuarios.map(usuario => ({
        ...usuario,
        nombreCompleto: `${usuario.nombre} ${usuario.primerApellido} ${usuario.segundoApellido || ''}`.trim()
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.usuarios-lista {
  padding: 1.5rem;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.content-header-title {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.content-header-subtitle {
  color: #6c757d;
  margin-bottom: 0;
}
</style>
